import { render, staticRenderFns } from "./TroskoviVozila.vue?vue&type=template&id=f289e6dc&"
import script from "./TroskoviVozila.vue?vue&type=script&lang=ts&"
export * from "./TroskoviVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports